export const USER_VALIDITY_UNKNOWN = Symbol('USER_VALIDITY_UNKNOWN')
export const VALIDATING_USER = Symbol('VALIDATING_USER')
// Setting value as a symbol prevents users from setting their user valid from the console
export const VALID_USER = Symbol('VALID_USER')
export const INVALID_USER = Symbol('INVALID_USER')
